// extracted by mini-css-extract-plugin
module.exports = {"infoWrap":"other-info_infoWrap_C3VA4","infoItem":"other-info_infoItem_y_XeL","label":"other-info_label_DI1TU","value":"other-info_value_3zZDq"};